import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Sensor} from '../classes/Sensor';

const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: 'root',
})
export class SensorService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<Sensor[]> {
    return this.httpClient.get<Sensor[]>(`${environment.backendApiUrl}/v1/sensors`, {headers});
  }

  public getByRelayBoard(relayBoardId: number): Observable<Sensor[]> {
    const params = new HttpParams().append('relayBoardId', relayBoardId);
    return this.httpClient.get<Sensor[]>(`${environment.backendApiUrl}/v1/sensors`, {params, headers});
  }

  public addOrEdit(sensor: Sensor): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/sensors`, sensor, {headers});
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/sensors/` + id, {headers});
  }
}
